import { createAction, props } from '@ngrx/store';
import {
  ApplicantAppEntityApplicantWrite,
  ApplicationAppEntityApplicationRead,
  ApplicationAppEntityApplicationWrite,
  AttachmentAttachmentRead,
  InvestorRepresentativeAppEntityInvestorRepresentativeWrite, ParcelAppEntityParcelWrite,
  PatchContractorContractorItemRequestParams, TaxObjectAppEntityTaxObjectWrite
} from '../../openapi';
import { ApplicationCode } from '../../services/application.common.service';
import { ApplicationListItem, ApplicationPayment, AttachmentPositions } from '../../services/application.common.model';

export const createApplication = createAction(
  '[Application] create application',
  props<{
    serviceTypeId: string;
    application: ApplicationAppEntityApplicationWrite;
    successFnc: (application: ApplicationAppEntityApplicationRead) => void;
    failureFnc: () => void;
  }>()
);

export const createApplicationSuccess = createAction(
  '[Application] create application success',
  props<{ application: ApplicationAppEntityApplicationRead }>()
);

export const createApplicationFailure = createAction('[Application] create application failure');

export const setApplication = createAction('[Application] set application', props<{
  application: ApplicationAppEntityApplicationRead | null
}>());

export const loadApplication = createAction('[Application] load application', props<{ id: string }>());

export const loadApplicationSuccess = createAction(
  '[Application] load application success',
  props<{ application: ApplicationAppEntityApplicationRead | null }>()
);

export const loadApplicationFailure = createAction(
  '[Application] load application failure'
);

export const updateApplication = createAction(
  '[Application] update application data',
  props<{
    id: string;
    application: ApplicationAppEntityApplicationWrite;
    successFnc: (applicationId: ApplicationAppEntityApplicationRead) => void;
    failureFnc: () => void;
  }>()
);

export const updateApplicationSuccess = createAction(
  '[Application] update application data success',
  props<{ application: ApplicationAppEntityApplicationRead }>()
);

export const updateApplicationFailure = createAction(
  '[Application] update application data failure'
);

export const updateTaxObjectsData = createAction(
  '[Application] update application tax objects data',
  props<{
    application: ApplicationAppEntityApplicationRead;
    taxObjects: TaxObjectAppEntityTaxObjectWrite[];
    successFnc: (applicationId: string) => void;
    failureFnc: () => void;
  }>()
);

export const updateTaxObjectsDataSuccess = createAction(
  '[Application] update application tax objects data success',
  props<{ application: ApplicationAppEntityApplicationRead }>()
);

export const updateTaxObjectsDataFailure = createAction(
  '[Application] update application tax objects data failure'
);

export const updateApplicantData = createAction(
  '[Application] update applicant data',
  props<{
    application: ApplicationAppEntityApplicationRead,
    applicationPayload: ApplicationAppEntityApplicationWrite,
    applicantPayload: ApplicantAppEntityApplicantWrite,
    successFnc: (applicationId: string) => void;
    failureFnc: () => void;
  }>()
);

export const updateApplicantDataSuccess = createAction(
  '[Application] update applicant data success',
  props<{ application: ApplicationAppEntityApplicationRead }>()
);

export const updateApplicantDataFailure = createAction('[Application] update applicant data failure');

export const updateContractors = createAction(
  '[Application] update contractors',
  props<{
    applicationId: string;
    contractors: PatchContractorContractorItemRequestParams[];
    successFnc: (applicationId: string) => void;
    failureFnc: () => void;
  }>()
);

export const updateContractorsSuccess = createAction(
  '[Application] update contractors success',
  props<{ application: ApplicationAppEntityApplicationRead }>()
);

export const updateContractorsFailure = createAction('[Application] update contractors failure');

export const updateApplicationAttachments = createAction(
  '[Application] update application attachments',
  props<{
    application: ApplicationAppEntityApplicationRead,
    attachments: AttachmentAttachmentRead[],
    successFnc: (applicationId: string) => void,
    failureFnc: () => void
  }>()
);

export const updateApplicationAttachmentsSuccess = createAction(
  '[Application] update application attachments success',
  props<{ application: ApplicationAppEntityApplicationRead }>()
);

export const updateApplicationAttachmentsFailure = createAction(
  '[Application] update application attachments failure'
);

export const loadApplicationList = createAction(
  '[Application] load application list',
  props<{ code: ApplicationCode }>()
);

export const loadApplicationListSuccess = createAction(
  '[Application] load application list success',
  props<{ applicationList: ApplicationListItem[] }>()
);

export const loadApplicationListFailure = createAction(
  '[Application] load application list failure'
);

export const approveApplication = createAction(
  '[Application] approve',
  props<{
    applicationId: string,
    successFnc: () => void,
    failureFnc: () => void
  }>()
);

export const approveApplicationSuccess = createAction(
  '[Application] approve success',
  props<{ application: ApplicationAppEntityApplicationRead }>()
);

export const approveApplicationFailure = createAction(
  '[Application] approve failure'
);

export const setPayments = createAction(
  '[Application] set payments',
  props<{ applicationPayment: ApplicationPayment | null }>()
);

export const loadPayments = createAction(
  '[Application] load payments',
  props<{ applicationId: string }>()
);

export const loadPaymentsSuccess = createAction(
  '[Application] load payments success',
  props<{ applicationPayment: ApplicationPayment | null }>()
);

export const loadPaymentsFailure = createAction('[Application] load payments failure');

export const sendApplication = createAction('[Application] send',
  props<{
    applicationId: string;
    successFnc: () => void;
    failureFnc: () => void;
  }>()
);

export const sendApplicationSuccess = createAction(
  '[Application] send application success'
);

export const sendApplicationFailure = createAction('[Application] send application failure');

export const signApplication = createAction(
  '[Application] sign application',
  props<{
    applicationId: string;
    successFnc: (redirectUrl: string) => void;
    failureFnc: () => void;
  }>()
);

export const signApplicationSuccess = createAction('[Application] sign application success');

export const signApplicationFailure = createAction('[Application] sign application failure');

export const fakeSignApplication = createAction('[Application] fake sign application', props<{
    applicationId: string;
    successFnc: () => void;
    failureFnc: () => void;
  }>()
);

export const fakeSignApplicationSuccess = createAction(
  '[Application] fake sign application success'
);

export const fakeSignApplicationFailure = createAction('[Application] fake sign application failure');

export const updateInvestorRepresentatives = createAction('[Application] update investor representatives', props<{
  currentApp: ApplicationAppEntityApplicationRead,
  payload: ApplicationAppEntityApplicationWrite,
  investorRepresentatives: InvestorRepresentativeAppEntityInvestorRepresentativeWrite[];
  successFnc: (applicationId: string) => void;
  failureFnc: () => void;
}>());

export const updateInvestorRepresentativesSuccess = createAction(
  '[Application] update investor representatives success',
  props<{ application: ApplicationAppEntityApplicationRead }>()
);

export const updateInvestorRepresentativesFailure = createAction('[Application] update investor representatives failure');

export const loadServiceAttachmentPositions = createAction(
  '[Application] load service attachment positions',
  props<{
    appId: string
  }>()
);

export const loadServiceAttachmentPositionsSuccess = createAction(
  '[Application] load service attachment positions success',
  props<{
    serviceAttachmentPositions: AttachmentPositions
  }>()
);

export const loadServiceAttachmentPositionsFailure = createAction(
  '[Application] load service attachment positions failure'
);

export const updateParcels = createAction(
  '[Application] update parcels',
  props<{
    currentApp: ApplicationAppEntityApplicationRead;
    parcels: ParcelAppEntityParcelWrite[];
    successFnc: (applicationId: string) => void;
    failureFnc: () => void;
  }>()
);

export const updateParcelsSuccess = createAction(
  '[Application] update parcels success',
  props<{ application: ApplicationAppEntityApplicationRead }>()
);

export const updateParcelsFailure = createAction(
  '[Application] update parcels failure'
);
